import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function NotFound() {
  const location = useLocation();
  const { t } = useTranslation();

  return (
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-[#8B6F5C]/10 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <h1 className="text-xl md:text-2xl font-semibold text-[#8B6F5C] mt-6">{t('notfound.title')}</h1>
        <p className="mt-2 text-base text-[#5C4A3A] font-mono">{location.pathname}</p>
        <p className="mt-4 text-lg md:text-xl text-[#3D2B1F]">{t('notfound.desc')}</p>
      </div>
    </div>
  );
}